import React, { Fragment } from 'react';
import { Link } from 'react-router-dom';
import EbookForm from '../../widgets/EbookForm'
import Img from '../../widgets/Img';
import img1 from './imgs/discover.jpg';
import img2 from './imgs/master.jpg';
import img3 from './imgs/transform.jpg';
import img4 from '../page-imgs/MockUp_4.png';
import './home.css';

const Home = () => {

    return (
        <Fragment>
            <div className="jumbotron home">
                <div className="container text-light">
                    <h1 className="display-4"><span className="text-danger">Shift</span> Your Mindset</h1>
                    <p className="lead">9 Fundamentals to Personally Transform Your Life & Business</p>
                    <hr className="my-4" />
                    <p>Get the copy of the FREE Ebook Today, by just sigining up with your name and email, you’ll be able to be ahead of the game by uncovering the first 4 fundamentals to begin your journey of personal transformation.</p>
                    <a style={{marginTop: '1rem'}} className="btn btn-danger btn-lg" href="#" role="button">Get your free Ebook now!</a>
                </div>
            </div>

            <div className="container">
                <div className="row">
                    <div className="col-lg align-center">
                        <div className='center-sm align-text-left'>
                            <h1><span className="text-danger">Shift</span>Mindset</h1>
                            <p className="text-nc">9 Fundamentals to Personally Transform Your Life & Business</p>
                            <p>Don’t miss out on contributing to your personal transformation through the fundamentals discovered in this book. Stop Complaining and Start Changing with the 9 Important fundamentals to personal transformation.</p>
                            <Link style={{marginTop: '1rem', display: 'block'}} className="btn btn-danger" to='/'>Pre-Order Now</Link>
                        </div>
                    </div>
                    <div className="col-lg">
                        <img style={{width: '100%'}} src={img4} alt=""/>
                    </div>
                </div>
            </div>

            <div className="bg-dark center-margin">
                <div className="container">
                    <div className="row center-sm">
                        <div className="col-lg align-center text-light">
                            <div >
                                <h2><span className="text-danger">Discover</span> Your Mind</h2>
                                <ul style={{fontSize: '1.2em'}}>
                                    <li>Creating a powerful vision which influences you to act and achieve results</li>
                                    <li>Understanding the centre of your success influence and defining your own sense of achievement</li>
                                    <li>Understanding personal patterns that controls your decisions, belief systems and habits</li>
                                </ul>
                            </div>
                        </div>
                        <div className="col-lg">
                            <div className="full-height">
                                <Img url={img1}/>
                            </div>
                        </div>
                    </div>

                    <div className="row">
                        <div className="col-lg order-lg-12 align-center text-light">
                            <div>
                                <h2><span className="text-danger">Master</span> Your Mind</h2>
                                <ul style={{fontSize: '1.2em'}}>
                                    <li>Becoming aware of your environment to influence the mind and drive yourself to manifest results</li>
                                    <li>Mastering your mental environmental barriers which influence every aspect of your life</li>
                                    <li>Becoming the boss of your emotions and understanding how to take control over your emotional influence</li>
                                </ul>
                            </div>
                        </div>
                        <div className="col-lg order-lg-1">
                            <div className="full-height">
                                <Img url={img2}/>
                            </div>
                        </div>
                    </div>

                    <div className="row center-sm">
                        <div className="col-lg align-center text-light">
                            <div >
                                <h2><span className="text-danger">Transform</span> Yourself</h2>
                                <ul style={{fontSize: '1.2em'}}>
                                    <li>The TARR method to developing new habits which are going to contribute to your personal transformation</li>
                                    <li>Understanding strong influential energy patterns which alter your belief systems and develop your reality</li>
                                    <li>Transforming yourself, your relationships, your business, your health & every part of your life</li>
                                </ul>
                            </div>
                        </div>
                        <div className="col-lg">
                            <div className="full-height">
                                <Img url={img3}/>
                            </div>
                        </div>
                    </div>
                </div>
                
            </div>
            
            <div className="container">
                <div className="row">
            
                    <div className="col-lg center-margin">
                        <div className="card shadow full-height">
                            <div className='space'>
                                <h2 className="text-danger center-hori">Pre-Order Now!</h2>
                                <h5 className="center-hori">Exclusive Pre-Order Offer:</h5>
                                <ul className='center-xs space'>
                                    <li>Full Signed Copy Including Bonus Chapter on the Mindset of Marketing</li>
                                    <li>Instant Access to Free Online Webinar Sessions</li>
                                    <li>Free 30 minute Online/Live Consultation</li>
                                    <li>Access to free resources/templates</li>
                                </ul>
                                <div className="center-hori">
                                    <Link className="btn btn-danger" to='/'>Pre-Order</Link>
                                </div>
                            </div>
                        </div>
                    </div>
                    

                    <div className="col-lg center-margin">
                        <div className="card shadow center-hori full-height">
                            <div className="space">
                                <h2>Emaginetalks Publishing</h2>
                                <p className="center-xs">Get your business book completely published by Emaginetalks With a couple of different options of learning how to Self-Publish or getting your book represented through one of Emaginetalks Publishing Plans that could get your book not only published but printed in 90 Days Time… Guaranteed!</p>
                                <Link className="btn btn-danger" to='/'>Get Published</Link>
                            </div>
                        </div>
                    </div>
                </div>

                <div className="center-xs">
                <EbookForm />
                </div>
            </div>
            

            
        </Fragment>
    )
}



export default Home
